import { createComponent } from '@lit-labs/react';
import React from 'react';

export class GenderInputDS extends HTMLElement {
  class?: string;
  value: unknown;
  label?: string;
  constructor() {
    super();
  }
}

export const GenderInput = createComponent(React, 'gender-input', GenderInputDS, {
  onSelectedElementChange: 'selected-element-changed',
  onSelectedChange: 'selected-changed',
});
